import React, { useState, useEffect } from 'react';
import * as qf from '../misc/qf';

const ShowcaseBtn = ({ media, el }) => {
  const [showBtn, setShowBtn] = useState(false);
  const [showcased, setShowcased] = useState(false);
  const [contextLinks, setContextLinks] = useState(undefined);

  const setShowcase = () => {
    if (showcased) {
      qf.del(contextLinks._links.showcase.href)
        .then( res => {
          setShowcased(false);
        })
        .catch( err => console.error(err) );
    } else {
      qf.post(contextLinks._links.showcase.href)
        .then( res => {
          setShowcased(true);
        })
        .catch( err => console.error(err) );
    }
  };

  useEffect( () => {
    qf.getJSON(media._links.context_actions.href)
      .then( res => {
        if (!res._links.showcase) {
          el.remove();
        } else {
          setShowcased(res.showcased);
          setContextLinks(res);
          setShowBtn(true);
        }
      })
      .catch( err => console.error(err));
  }, [])

  if (!showBtn) {
    return (<></>)
  };

  return (
    <a onClick={setShowcase}>
      { showcased ? (<i className="fa-solid fa-trophy"></i>) : (<i className="fa-regular fa-trophy"></i>)} Showcase
    </a>
  )
}

export default ShowcaseBtn;
